// extracted by mini-css-extract-plugin
export var contentBody = "_5w-9";
export var headerImage = "_5w-2";
export var imageButton = "_5w-7";
export var imageButtonIcon = "_5w-8";
export var imageHeader = "_5w-4";
export var imageHeaderText = "_5w-5";
export var imageOverlay = "_5w-3";
export var imageTitle = "_5w-6";
export var imageWrapper = "_5w-1";
export var taskList = "_5w-a";
export var widget = "_5w-0";